// 51全网 —— 资源聚合 / 工具导航 分类数据（模拟数据，用于静态展示与搜索、收藏交互）
export interface ResourceItem {
  id: string;
  name: string;
  desc: string;
  icon: string;
  tag: string;
  extra: string;
}

export interface ResourceCategory {
  id: string;
  name: string;
  sub: string;
  intro: string;
  list: ResourceItem[];
}

export const categories: ResourceCategory[] = [
  {
    id: 'efficiency',
    name: '效率办公',
    sub: '效率工具',
    intro: '覆盖文档、表单、网盘、录屏与时间管理的常用效率工具，把重复工作压缩到最短。',
    list: [
      { id: 'eff-1', name: '云端协作文档', desc: '多人实时编辑、支持大纲与评论，适合团队与个人沉淀知识库。', icon: 'ri-file-text-line', tag: '在线文档', extra: '免费可用' },
      { id: 'eff-2', name: '在线问卷收集', desc: '拖拉表单即可搭建问卷，自动生成统计图表，回收反馈更省心。', icon: 'ri-survey-line', tag: '表单', extra: '免登录' },
      { id: 'eff-3', name: '大文件极速网盘', desc: '免安装网页直传，分享链接自动清理，大文件临时中转不占内存。', icon: 'ri-cloud-line', tag: '网盘传输', extra: '不限速' },
      { id: 'eff-4', name: '屏幕录制与剪辑', desc: '录屏、标注、配音一气呵成，输出高清教学与演示视频。', icon: 'ri-vidicon-line', tag: '录屏', extra: '网页可用' },
      { id: 'eff-5', name: '密码保险箱', desc: '加密保存各类账号密码，自动生成高强度密码并跨端同步。', icon: 'ri-lock-password-line', tag: '安全管理', extra: '加密' },
      { id: 'eff-6', name: '番茄钟专注清单', desc: '把任务拆成番茄块，配合白噪音帮助快速进入专注状态。', icon: 'ri-timer-line', tag: '时间管理', extra: '轻量' },
    ],
  },
  {
    id: 'design',
    name: '设计灵感',
    sub: '设计',
    intro: '汇集配色、版式、插画与网页灵感参考，启动项目前先找对方向。',
    list: [
      { id: 'des-1', name: '品牌配色灵感库', desc: '按情绪与行业分类的可商用配色方案，一键复制色值。', icon: 'ri-palette-line', tag: '配色', extra: '分类清晰' },
      { id: 'des-2', name: '版式与海报参考', desc: '聚合国内外优质海报与平面排版，按题材检索参考。', icon: 'ri-layout-masonry-line', tag: '版式', extra: '持续更新' },
      { id: 'des-3', name: '插画风格图集', desc: '整理多元插画风格与创作思路，适合手绘与商业插画找方向。', icon: 'ri-ink-bottle-line', tag: '插画', extra: '风格多样' },
      { id: 'des-4', name: '网页设计灵感', desc: '按落地页、电商、SaaS 等场景归类的优质网页案例集合。', icon: 'ri-global-line', tag: 'Web 灵感', extra: '场景分类' },
      { id: 'des-5', name: 'Logo 与 VI 灵感', desc: '优秀品牌标识与视觉识别案例，可作命名与造型的起点。', icon: 'ri-mark-pen-line', tag: 'Logo', extra: '原创参考' },
      { id: 'des-6', name: 'UI 组件灵感', desc: '按钮、卡片、导航等界面组件范例，设计系统搭建参考。', icon: 'ri-apps-2-line', tag: 'UI', extra: '可复用' },
    ],
  },
  {
    id: 'material',
    name: '素材资源库',
    sub: '素材',
    intro: '图片、图标、字体、音效等免版权素材一站搜罗，商用也不慌。',
    list: [
      { id: 'mat-1', name: '免费商用图库', desc: '高质量可商用摄影图，按关键词快速找大图素材。', icon: 'ri-image-line', tag: '图片', extra: '可商用' },
      { id: 'mat-2', name: '矢量图标集', desc: '线性与填充两套图标体系，支持按名称即时检索。', icon: 'ri-shapes-line', tag: '图标', extra: '免版权' },
      { id: 'mat-3', name: '中文字体仓库', desc: '免费商用中文字体按风格整理，标题与正文各取所需。', icon: 'ri-font-size', tag: '字体', extra: '免费商用' },
      { id: 'mat-4', name: '免版权音效库', desc: 'BGM、白噪音与短音效集中收录，为视频与产品配音效。', icon: 'ri-music-2-line', tag: '音频', extra: '商用授权' },
      { id: 'mat-5', name: '高清视频素材', desc: '电影感与场景化免费视频素材，覆盖多类叙事需求。', icon: 'ri-film-line', tag: '视频', extra: '高清' },
      { id: 'mat-6', name: '渐变与贴图素材', desc: '配色渐变、纸张纹理与背景贴图打包下载，铺底更省事。', icon: 'ri-gradienter-line', tag: '贴图', extra: '即下即用' },
    ],
  },
  {
    id: 'dev',
    name: '开发编程',
    sub: '开发',
    intro: '代码检索、在线调试与常用转换工具，让写码与排查更顺手。',
    list: [
      { id: 'dev-1', name: '代码片段检索', desc: '按语言与关键词搜索高质量代码片段与使用说明。', icon: 'ri-code-s-slash-line', tag: '代码', extra: '多语言' },
      { id: 'dev-2', name: '在线正则调试', desc: '实时高亮匹配结果，可视化拆解复杂正则表达式。', icon: 'ri-function-line', tag: '正则', extra: '实时预览' },
      { id: 'dev-3', name: 'JSON 格式化', desc: '一键美化、校验与转换 JSON，支持路径查询与压缩。', icon: 'ri-braces-line', tag: '格式化', extra: '本地处理' },
      { id: 'dev-4', name: '图标字体生成', desc: '上传图标合并为字体并导出，前端引用的经典方案。', icon: 'ri-font-family', tag: '图标字体', extra: '自动导出' },
      { id: 'dev-5', name: '接口调试工具', desc: '构造请求、验证鉴权与响应，前后端联调更高效。', icon: 'ri-terminal-box-line', tag: 'API', extra: '可保存' },
      { id: 'dev-6', name: '在线配色生成', desc: '基于色轮生成和谐配色，输出可直接使用的色板。', icon: 'ri-water-flash-line', tag: '配色', extra: '一键生成' },
    ],
  },
  {
    id: 'ai',
    name: 'AI 智能工具',
    sub: 'AI',
    intro: '写作、绘图、问答到翻译转写，把 AI 能力接到日常任务里。',
    list: [
      { id: 'ai-1', name: 'AI 写作助手', desc: '生成大纲、改写润色与标题，文案灵感不再卡壳。', icon: 'ri-edit-box-line', tag: '写作', extra: '多模板' },
      { id: 'ai-2', name: 'AI 绘画生成', desc: '按描述生成插画与海报底图，风格与比例可微调。', icon: 'ri-robot-2-line', tag: '绘图', extra: '风格多样' },
      { id: 'ai-3', name: '智能对话问答', desc: '多轮上下文问答，兼顾资料梳理与方案头脑风暴。', icon: 'ri-chat-ai-line', tag: '问答', extra: '多轮对话' },
      { id: 'ai-4', name: 'AI 翻译润色', desc: '中英互译与语气润色，商务、学术文本表达更地道。', icon: 'ri-translate-2', tag: '翻译', extra: '支持多语' },
      { id: 'ai-5', name: '语音转文字', desc: '会议录音一键成稿，自动分段并整理关键纪要。', icon: 'ri-mic-line', tag: '转写', extra: '高准确' },
      { id: 'ai-6', name: 'AI 一键做 PPT', desc: '输入主题生成演示文稿骨架，再按偏好换风格。', icon: 'ri-presentation-line', tag: 'PPT', extra: '快速出稿' },
    ],
  },
  {
    id: 'template',
    name: '模板与文档',
    sub: '模板',
    intro: '简历、演示、合同与图表模板合集，按用途直接套用再微调。',
    list: [
      { id: 'tpl-1', name: '简历模板合集', desc: '多种风格简历模板，导入内容即可导出 PDF 投递。', icon: 'ri-file-user-line', tag: '简历', extra: '可下载' },
      { id: 'tpl-2', name: 'PPT 演示模板', desc: '汇报、路演与课件模板分区整理，主题统一好上手。', icon: 'ri-slideshow-4-line', tag: 'PPT 模板', extra: '风格齐全' },
      { id: 'tpl-3', name: '合同协议范本', desc: '常用劳动合同、租赁与合作协议示例，仅供起草参考。', icon: 'ri-file-shield-2-line', tag: '合同', extra: '需复核' },
      { id: 'tpl-4', name: 'Excel 图表模板', desc: '预算、排期与看板模板，套入数据自动出图。', icon: 'ri-bar-chart-box-line', tag: '表格', extra: '公式内置' },
      { id: 'tpl-5', name: '通知公告模板', desc: '单位通知、会议纪要等公文模板，措辞规范可套用。', icon: 'ri-megaphone-line', tag: '公文', extra: '措辞规范' },
      { id: 'tpl-6', name: '论文排版模板', desc: '开题、报告与参考文献格式模板，降低排版负担。', icon: 'ri-book-open-line', tag: '论文', extra: '格式齐全' },
    ],
  },
  {
    id: 'learn',
    name: '学习与资料',
    sub: '学习',
    intro: '公开课、电子书、行业报告与训练营资料导航，按需进阶。',
    list: [
      { id: 'lrn-1', name: '公开课聚合', desc: '名校与行业课程统一入口，按学科与难易程度挑选。', icon: 'ri-graduation-cap-line', tag: '公开课', extra: '免费资源' },
      { id: 'lrn-2', name: '电子书资源', desc: '技术、经管与人文类电子书分类收录，随读随取。', icon: 'ri-book-2-line', tag: '电子书', extra: '分类齐全' },
      { id: 'lrn-3', name: '技能训练营', desc: '职场办公与工具技能短课，碎片时间也能学完一门。', icon: 'ri-lightbulb-line', tag: '技能课', extra: '短课为主' },
      { id: 'lrn-4', name: '行业报告库', desc: '各行业趋势与数据报告汇总，供调研与写作引用。', icon: 'ri-file-chart-line', tag: '报告', extra: '持续上新' },
      { id: 'lrn-5', name: '期刊论文导航', desc: '学术数据库与预印本入口整理，检索文献少走弯路。', icon: 'ri-article-line', tag: '论文检索', extra: '权威入口' },
      { id: 'lrn-6', name: '备考题库整理', desc: '考证与面试常见题型归纳，配套参考答案与思路。', icon: 'ri-question-answer-line', tag: '题库', extra: '附带解析' },
    ],
  },
  {
    id: 'useful',
    name: '实用网站收录',
    sub: '好站',
    intro: '短链、二维码、压缩与格式转换等高频小工具常备入口。',
    list: [
      { id: 'usf-1', name: '短链接生成', desc: '把冗长网址转成易分享的短链，支持自定义与统计。', icon: 'ri-links-line', tag: '短链', extra: '可自定义' },
      { id: 'usf-2', name: '二维码制作', desc: '链接、文本一键转码，可调节容错率与样式。', icon: 'ri-qr-code-line', tag: '二维码', extra: '即生成' },
      { id: 'usf-3', name: '在线图片压缩', desc: '本地压缩保持画质，输出体积更小的常用格式。', icon: 'ri-image-edit-line', tag: '图片压缩', extra: '本地处理' },
      { id: 'usf-4', name: '文档格式转换', desc: 'PDF、Word、图片互转，批量处理保持版式。', icon: 'ri-file-transfer-line', tag: '格式转换', extra: '批量' },
      { id: 'usf-5', name: '快递物流聚合', desc: '多平台快递单号统一查询，一次输入搞定跟踪。', icon: 'ri-truck-line', tag: '物流', extra: '统一入口' },
      { id: 'usf-6', name: '汇率与单位换算', desc: '多币种汇率与常用单位即时换算，出差写作常备。', icon: 'ri-exchange-funds-line', tag: '换算', extra: '实时汇率' },
    ],
  },
];

export const hotTags: string[] = [
  '在线文档',
  'PPT 模板',
  '免费商用图库',
  '简历模板',
  'AI 写作',
  '图标素材',
  '视频素材',
  '时间管理',
];